export class Global {
  constructor() {
    /* 用户名 */
    this.user = null
    this.activeRoute = 'Home'
    /* 我的订单 切换 */
    this.orderTab = 'order'
    /* 课程分类 */
    this.courseCategory = 'all'
    /* 课程主题 */
    this.courseTheme = 'all'
    /* 登录状态 */
    this.isLogin = false
    this.dialogVisible = false
    this.currentOrder = null
    this.categoryList = []

    /* 课程详情 */
    this.courseInfo =  null

    // 用户付费协议标识
    this.isAgree = false
    // this.courseInfo = {
    //   title: '电子海图--航次计划',
    //   cover: 'black-ship',
    //   studentCount: 1938,
    //   rating: 4,
    //   ratingText: '',
    //   price: '300.00',
    //   validity: 180,
    //   tags: ['真题详解', '视频课程', '仿真设备', '智能评估', '学练综合'],
    //   url: 'https://www.xmhgapi.com/hgOnline/hgLibrary/'
    // }
  }
}